import React from 'react';
import { Table } from 'reactstrap';
import _ from 'lodash-es';
import { LowboyAssignmentStatuses } from './LowboyAssignmentStatuses';
import cls from 'classnames';

export default class LowboyDispatchScoreboard extends React.Component {
    getCounts() {
        const { lowboyResources, lowboyAssignments } = this.props;

        const totalRequestedResources = _.sumBy(
            lowboyResources,
            'requestedResourceCount'
        );

        const planned = lowboyAssignments.filter(
            (la) =>
                la.lowboyAssignmentStatusId == LowboyAssignmentStatuses.Planned
        ).length;

        const dispatched = lowboyAssignments.filter(
            (la) =>
                la.lowboyAssignmentStatusId ==
                LowboyAssignmentStatuses.Dispatched
        ).length;

        const confirmed = lowboyAssignments.filter(
            (la) =>
                la.lowboyAssignmentStatusId >=
                LowboyAssignmentStatuses.Confirmed
        ).length;

        return {
            unassigned:
                totalRequestedResources - planned - dispatched - confirmed,
            planned,
            dispatched,
            confirmed,
        };
    }

    render() {
        const scorecardCounts = this.getCounts();

        return (
            <Table bordered={true} size="sm">
                <thead>
                    <tr>
                        <th>Unassigned</th>
                        <th>Planned</th>
                        <th>Dispatched</th>
                        <th>Confirmed</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td
                            className={cls({
                                'text-danger': scorecardCounts.unassigned,
                            })}
                        >
                            {scorecardCounts.unassigned}
                        </td>
                        <td
                            className={cls({
                                'text-warning': scorecardCounts.planned,
                            })}
                        >
                            {scorecardCounts.planned}
                        </td>
                        <td
                            className={cls({
                                'text-info': scorecardCounts.dispatched,
                            })}
                        >
                            {scorecardCounts.dispatched}
                        </td>
                        <td
                            className={cls({
                                'text-success': scorecardCounts.confirmed,
                            })}
                        >
                            {scorecardCounts.confirmed}
                        </td>
                    </tr>
                </tbody>
            </Table>
        );
    }
}
